import { Helmet } from 'react-helmet-async';

import { Content } from './components/Content';

export const AdminSMSCountriesList = () => {
  return (
    <>
      <Helmet>
        <title>SMS Countries list - AutoScript Admin</title>
      </Helmet>
      <Content />
    </>
  );
};
